module.exports = __webpack_public_path__ + "img/auth-bg.43990ebe.png";